import { BaseProgressionStrategy } from './BaseProgressionStrategy.js';

export class DefaultProgressionStrategy extends BaseProgressionStrategy {
  build(ctx) {
    const len = ctx.scale.length;
    if (len === 5) {
      const choice = this.pick(ctx, [[0, 3, 0, 4], [0, 4, 0, 4], [0, 0, 0, 0]]);
      return choice.map(deg => this.triad(ctx, deg));
    }
    if (len >= 7) {
      const choice = this.pick(ctx, [[0, 4, 5, 3], [1, 4, 0], [5, 3, 0, 4], [0, 0, 0, 0], [0, 3, 4, 3]]);
      return choice.map(deg => this.triad(ctx, deg));
    }
    return [this.triad(ctx, 0), this.triad(ctx, 2), this.triad(ctx, 0), this.triad(ctx, 3)];
  }
}
